import { render, staticRenderFns } from "./importcol-grid.vue?vue&type=template&id=319249db&scoped=true"
import script from "./importcol-grid.vue?vue&type=script&lang=js"
export * from "./importcol-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319249db",
  null
  
)

export default component.exports